import { jsx as f } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import { cn as s } from "../../../lib/utils.mjs";
import { PaginationItemVariants as l } from "./PaginationItemVariants.mjs";
const p = n(({
  className: a,
  variant: t = "default",
  size: o = "default",
  disabled: i = !1,
  children: m,
  ...r
}, e) => /* @__PURE__ */ f("li", { ref: e, className: s(
  l({
    variant: t,
    size: o,
    disabled: i
  }),
  a
), ...r, children: m }));
p.displayName = "PaginationItem";
export {
  p as default
};
//# sourceMappingURL=PaginationItem.mjs.map
